 

const CardItem = ({ children }) => {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: '8px',
        padding: '16px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '14px'
      }}
    >
      {children}
    </div>
  );
};

export default CardItem;